function MyProfileNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="myprofile">
      <path stroke="#8E33FF" strokeLinecap="round" strokeWidth="1.5" d="M5.833 15v-.833A4.167 4.167 0 0110 10v0a4.167 4.167 0 014.167 4.167V15"></path>
      <path stroke="#8E33FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.5 3.1v13.8a.6.6 0 01-.6.6H3.1a.6.6 0 01-.6-.6V3.1a.6.6 0 01.6-.6h13.8a.6.6 0 01.6.6z"
      ></path>
    </svg>
  );
}

export default MyProfileNavIcon;
